
import React from 'react'

interface SearchCategoryCardProps {
  className?: string
  titleText: string
  bodyText: string
  icon: React.ReactNode
}

export function SearchCategoryCard({ className, titleText, bodyText, icon }: SearchCategoryCardProps) {
  const clonedIcon = React.cloneElement(icon as React.ReactElement, {
    className: 'w-8 h-8 mb-2'
  })
  return (
    <div className={`bg-white border border=[#B6CFF1] rounded-xl p-4 w-[220px] h-[170px] ${className}`}>
      {clonedIcon}
      <p className='text-sm text-[#586885] font-bold mb-1 md:mb-2'>{titleText}</p>
      <p className='text-xs text-[#586885] font-medium text-justify'>{bodyText}</p>
    </div>
  )
}